import { CART_MODEL_CLASS_NAME } from 'models/daos/cart/constants'
import { PROMO_CODE_MODEL_CLASS_NAME } from 'models/daos/promo-code/constants'
import { SETTINGS_MODEL_CLASS_NAME } from 'models/daos/settings/constants'

const USER_MODEL_CLASS_NAME = 'User'

const USER_MODEL_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  EMAIL: 'email',
  PASSWORD: 'password',
  FACEBOOK_ID: 'facebookId',
  FACEBOOK_TOKEN: 'facebookToken',
  FACEBOOK_EMAIL: 'facebookEmail',
  TWITTER_ID: 'twitterId',
  TWITTER_TOKEN: 'twitterToken',
  TWITTER_EMAIL: 'twitterEmail',
  GOOGLE_ID: 'googleId',
  GOOGLE_TOKEN: 'googleToken',
  GOOGLE_EMAIL: 'googleEmail',
  LAST_NAME: 'lastName',
  FIRST_NAME: 'firstName',
  FULL_NAME: 'fullName', // Not a real attribute, only used in the Frontend
  NAME: 'name',
  USER_MODEL_ROLE: 'role',
  VERIFIED_AT: 'verifiedAt',
  HELLBANNED_AT: 'hellbannedAt',
  AVATAR: 'avatar',
  AVATAR_THUMBNAIL: 'avatarThumbnail',
  BIO: 'bio',
  WEBSITE: 'website',
  USER_MODEL_GENDER: 'gender',
  BIRTHDAY: 'birthday',
  HEIGHT: 'height',
  HEIGHT_UNIT: 'heightUnit',
  WEIGHT: 'weight',
  WEIGHT_UNIT: 'weightUnit',
  USER_MODEL_BODY_TYPE: 'bodyType',
  USER_MODEL_GOAL: 'goal',
  LOCATION: 'location',
  TIMEZONE: 'timezone',
  CART: 'cart',
  PROMO_CODES: 'promoCodes',
  SETTINGS: 'settings'
}

const USER_MODEL_KEY_POINTER = USER_MODEL_KEY.NAME

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const USER_MODEL_ASSOCIATION = {
  [USER_MODEL_KEY.CART]: CART_MODEL_CLASS_NAME,
  [USER_MODEL_KEY.PROMO_CODES]: PROMO_CODE_MODEL_CLASS_NAME,
  [USER_MODEL_KEY.SETTINGS]: SETTINGS_MODEL_CLASS_NAME
}

const USER_MODEL_VALIDATOR = {
  [USER_MODEL_KEY.PASSWORD]: [
    6,
    60
  ],
  [USER_MODEL_KEY.NAME]: [
    1,
    32
  ],
  [USER_MODEL_KEY.BIO]: [
    0,
    160
  ],
  [USER_MODEL_KEY.FIRST_NAME]: [
    0,
    32
  ],
  [USER_MODEL_KEY.LAST_NAME]: [
    0,
    32
  ],
  [USER_MODEL_KEY.FULL_NAME]: [
    0,
    64
  ]
}

const USER_MODEL_VALIDATOR_MIN_AGE = 16
const USER_MODEL_PLACEHOLDER = {
  [USER_MODEL_KEY.NAME]: 'yourname',
  [USER_MODEL_KEY.FULL_NAME]: 'Your Full Name',
  [USER_MODEL_KEY.EMAIL]: 'yourname@example.com',
  [USER_MODEL_KEY.BIO]: 'Your bio goes here',
  [USER_MODEL_KEY.PASSWORD]: 'yourpassword',
  [USER_MODEL_KEY.BIRTHDAY]: 'MM/DD/YYYY',
  [USER_MODEL_KEY.WEBSITE]: 'https://www.yourwebsite.com',
  [USER_MODEL_KEY.HEIGHT]: 'Height',
  [USER_MODEL_KEY.WEIGHT]: 'Weight'
}

const USER_MODEL_ROLE = {
  ADMIN: 1,
  WRITER: 2
}

const USER_MODEL_GENDER = {
  MALE: 1,
  FEMALE: 2
}

const USER_MODEL_REGEX = {
  [USER_MODEL_KEY.NAME]: /^[a-z0-9_.-]+$/i
}

export {
  USER_MODEL_CLASS_NAME,
  USER_MODEL_KEY,
  USER_MODEL_KEY_POINTER,
  USER_MODEL_ASSOCIATION,
  USER_MODEL_VALIDATOR,
  USER_MODEL_VALIDATOR_MIN_AGE,
  USER_MODEL_PLACEHOLDER,
  USER_MODEL_ROLE,
  USER_MODEL_GENDER,
  USER_MODEL_REGEX
}
